/**
 * Constants for StructureNote feature
 * Eliminates magic numbers and centralizes configuration
 */

import { COLORS } from "../../constants/colors";

/**
 * Carousel configuration
 */
export const CAROUSEL_CONFIG = {
  ITEMS_PER_PAGE: 3,
  NAVIGATION_ICON_SIZE: 30,
} as const;

/**
 * Document viewer configuration
 */
export const DOCUMENT_CONFIG = {
  VIEWER_HEIGHT: 500,
  AGREEMENT_NAME: "Structured Note Subscription Agreement",
} as const;

/**
 * Button style configurations
 * Eliminates inline style duplication
 */
export const BUTTON_STYLES = {
  navigation: {
    padding: "10px",
    fontSize: "30px",
    fontWeight: "bolder" as const,
    borderRadius: "80px",
    border: "none",
  },
  subscribe: {
    color: "white",
    backgroundColor: COLORS.agreementFont,
    borderRadius: "5px",
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
    padding: "12px 80px",
    fontSize: "20px",
    border: "none",
  },
} as const;

/**
 * Input field styles
 */
export const INPUT_STYLES = {
  investmentAmount: {
    padding: "7px 2px 7px 2px",
    outline: "none",
    borderColor: "#D9DCE1",
    marginBottom: 20,
    width: "40%",
    borderRadius: 3,
  },
} as const;

/**
 * Toast message IDs to prevent duplicates
 */
export const TOAST_IDS = {
  LOADING_LIVENESS: "loading-regtank-liveness-check-url",
} as const;

/**
 * Text content for UI
 */
export const UI_TEXT = {
  OFFER_ROOM_TITLE: "Offer Room",
  OFFER_ROOM_DESCRIPTION:
    "You may now deposit funds into your FundedHere Account and start your investment journey by subscribing to the investment notes below!",
  VIRTUAL_ACCOUNT_TITLE: "Virtual Account Details",
  ACCOUNT_PROCESSING: "Account creation is being processed.",
  AVAILABLE_BALANCE: "Available Balance",
  AMOUNT_TO_INVEST: "Amount to Invest",
  SUBSCRIBE_BUTTON: "Subscribe",
  AGREEMENT_TITLE: "Note Subscription Agreement",
  AGREEMENT_DESCRIPTION: "Please review and sign the agreement below.",
  SUFFICIENT_FUNDS_WARNING:
    "Before proceeding, please ensure that your account has sufficient funds.",
  PROCEED_TO_SIGN: "Proceed to Sign",
  SIGN_ACKNOWLEDGEMENT:
    'By clicking "Proceed to Sign", you acknowledge that you have read, understood and agree to be bound by the agreement above.',
  OKAY_BUTTON: "Okay",
  FAILED_LIVENESS_TITLE: "Agreement Signing Unsuccessful",
  FAILED_LIVENESS_MESSAGE_1:
    "Your agreement signing could not be completed as your identity verification was unsuccessful.",
  FAILED_LIVENESS_MESSAGE_2:
    "Our onboarding team is reviewing the matter to identify the issue. Once the review is complete, we will notify you by email and provide guidance on when you may reattempt verification.",
  FAILED_LIVENESS_MESSAGE_3: "Thank you for your patience and understanding.",
  DISABLED_BUTTON_MESSAGE:
    "Agreement signing is temporarily disabled until a new verification attempt is allowed.",
} as const;
